import { useCallback } from 'react'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

const PAGE_TYPE = 'item_page'

const CTA_CLICK_FLUSH_TIMEOUT_MS = 1000

const useItemPageSubscriptionTracking = ({ itemId, trackingPayload = EMPTY_OBJECT }) => {
  const { trackEvent } = useTracker()

  const {
    subscription_tier: subscriptionTier,
    widget_variant: widgetVariant,
    price_band: priceBand,
    displayed_price: displayedPrice,
    user_subscription_state: userSubscriptionState,
  } = trackingPayload

  const trackWidgetVisible = useCallback(() => {
    trackEvent(SubscriptionEvents.WIDGET_VISIBLE, {
      page_type: PAGE_TYPE,
      item_id: itemId,
      subscription_tier: subscriptionTier,
      widget_variant: widgetVariant,
      price_band: priceBand,
      displayed_price: displayedPrice,
      user_subscription_state: userSubscriptionState,
    })
  }, [trackEvent, itemId, subscriptionTier, widgetVariant, priceBand, displayedPrice, userSubscriptionState])

  const trackCtaClick = useCallback((ctaAction, onComplete) => {
    trackEvent(
      SubscriptionEvents.ITEM_CTA_CLICK,
      {
        page_type: PAGE_TYPE,
        item_id: itemId,
        subscription_tier: subscriptionTier,
        cta_action: ctaAction,
        displayed_price: displayedPrice,
        user_subscription_state: userSubscriptionState,
      },
      typeof onComplete === 'function'
        ? { eventCallback: onComplete, eventTimeout: CTA_CLICK_FLUSH_TIMEOUT_MS }
        : {}
    )
  }, [trackEvent, itemId, subscriptionTier, displayedPrice, userSubscriptionState])

  return {
    trackWidgetVisible,
    trackCtaClick,
  }
}

export default useItemPageSubscriptionTracking
